module.exports = "<h2 id=\"component-description\">Component Description</h2>\n<p>A Nessie Radio is a single radio input. It consists of a (hidden) html <code>&lt;input type=&quot;radio&quot;&gt;</code> button and a <code>&lt;label&gt;</code> styled to replace the native input.</p>\n<h2 id=\"example-usage\">Example Usage</h2>\n<pre><code>&lt;Radio isChecked={ true }&gt;My Radio&lt;/Radio&gt;\n</code></pre>";


//////////////////
// WEBPACK FOOTER
// ./node_modules/html-loader!./node_modules/markdown-loader!./src/Radio/README.md
// module id = 379
// module chunks = 0